<div class="modal-header">
    <h4 class="modal-title">{{ title || 'Confirm' }}</h4>
    <button type="button" class="close custom-close-btn" aria-label="Close" (click)="activeModal.dismiss('cancel')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <p>{{ message || 'Are you sure?' }}</p>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">
        {{ cancelText || 'Cancel' }}
    </button>
    <button type="button" class="btn btn-primary" (click)="activeModal.close('confirm')">
        {{ confirmText || 'Confirm' }}
    </button>
</div>